import {observer} from 'mobx-react-lite'
import React, {useCallback} from 'react'
import {Lang} from 'yougile-lang'
import {DataObjectId, SystemStickerType} from 'yougile-model'
import {PermissionsChecker} from '@client/permissions-checker'
import {AddUsersButton} from '@components/common/users-table/add-users-button'
import {UsersTable} from '@components/common/users-table/users-table'
import {MessageBox} from '@components/message-box'
import {StickerMenuHeader} from '@components/sticker/sticker-menu/sticker-menu-header'
import {
  useCanInvite,
  useUsersList
} from '@components/sticker/sticker-menu/sticker-menu-user/hooks'
import {useStickerStore} from '@components/sticker/sticker-store'
import {useAssignedUsers} from '@components/sticker/user-sticker'
import {PageService} from '@extensions/page-service'
import {Sticker} from '@extensions/sticker/sticker'

export const StickerMenuUserTask = observer(() => {
  const [state, store] = useStickerStore()
  const listUsers = useUsersList(store.stickerTask, store.sticker)
  const canInvite = useCanInvite()
  const proj = PageService.getCurrentProject()

  const assigned = useAssignedUsers(
    store.sticker,
    state.value,
    store.stickerTask
  )

  const canEdit =
    !store.stickerTask ||
    PermissionsChecker.checkEditTaskStickers(
      store.stickerTask,
      store.sticker,
      undefined
    )

  const onToggleSelectedUsers = useCallback(
    (userIds: DataObjectId[]) => {
      const userId = userIds[0]
      const task = store.stickerTask

      if (!task) {
        if (store.onPinHandler) {
          store.onPinHandler(
            assigned.includes(userId)
              ? assigned.filter(user => user !== userId)
              : [...assigned, userId]
          )
        }
        return
      }

      if (
        store.isTaskTemplate ||
        PermissionsChecker.checkAssignUser(store.stickerTask, userId)
      ) {
        Sticker.toggleUser(task, userId, task.id)
      } else {
        MessageBox.warn(Lang.msg.permissionsForbiddenAssignUser)
      }
    },
    [assigned]
  )

  return (
    <div className="min-w-[304px]">
      <div className="sticker-item-list-head flex">
        <StickerMenuHeader
          stickerId={store.sticker.id}
          title={
            Lang.msg.stickerNames[
              store.stickerData.stickerType as SystemStickerType
            ]
          }
          showUnpin={canEdit}
        />
      </div>
      <div className="sticker-item-list-body">
        <div className="h-[230px]">
          <UsersTable
            draggableUsers
            className="h-full"
            users={listUsers}
            selected={assigned}
            onDragStarted={store.startDragging}
            onDragStartedCallback={store.closeStickerMenu}
            onToggled={onToggleSelectedUsers}
          />
        </div>
        {canInvite && (
          <div className="bg-main-old border-solid border-0 border-t border-main-old">
            <AddUsersButton onClick={store.closeStickerMenu} project={proj} />
          </div>
        )}
      </div>
    </div>
  )
})
